
export default {
  // Auth-related translations
  "sign_in": "Iniciar sesión",
  "sign_up": "Registrarse",
  "email_address": "Correo electrónico",
  "password": "Contraseña",
  "new_password": "Nueva contraseña",
  "confirm_password": "Confirmar contraseña",
  "forgot_password": "¿Olvidaste tu contraseña?",
  "reset_password": "Restablecer contraseña",
  "verification_code": "Código de verificación",
  "enter_verification_code": "Ingresa el código de 6 dígitos enviado a tu correo electrónico",
  "passwords_dont_match": "Las contraseñas no coinciden",
  "password_too_short": "La contraseña debe tener al menos 8 caracteres",
  "invalid_code": "Código inválido o expirado",
  "invalid_code_format": "El código de verificación debe ser un número de 6 dígitos",
  "password_reset_success": "Contraseña restablecida con éxito",
  "send_reset_link": "Enviar contraseña temporal",
  "reset_link_sent": "Enlace de restablecimiento enviado a tu correo",
  "temp_password_sent": "Contraseña temporal enviada a tu correo",
  "reset_link_error": "Error al enviar el enlace de restablecimiento. Inténtalo de nuevo más tarde.",
  "email_delivery_not_configured": "El envío de correos no está configurado. Contacta al administrador.",
  "for_testing_use": "Para pruebas de desarrollo, puedes usar Supabase CLI o Dashboard para gestionar usuarios",
  "processing": "Procesando...",
  "back": "Volver",
  "verify_code": "Ingresar código de verificación",
  "email_not_received": "¿No recibiste el correo?",
  "leave_page_warning": "Tienes cambios sin guardar. ¿Estás seguro de que deseas abandonar esta página? Tu progreso de restablecimiento de contraseña se perderá.",
  "reset_link_required": "Se requiere un enlace de restablecimiento válido para restablecer tu contraseña",
  // New rate limit messages
  "reset_rate_limit_exceeded": "Se excedió el límite de envío de correos. Por favor, espera antes de intentarlo de nuevo.",
  "reset_rate_limit_message": "Por favor, espera {{seconds}} segundos antes de solicitar otro enlace de restablecimiento.",
  "wait_before_retry": "Espera antes de volver a intentar",
  // Temporary password messages
  "password_reset_required": "Debes cambiar tu contraseña para continuar",
  "temp_password_instructions": "Estás usando una contraseña temporal. Por favor, crea una nueva contraseña.",
  
  // Username dialog related translations
  "create_username": "Crear Nombre de Usuario",
  "username_required_description": "Por favor, crea un nombre de usuario para continuar. Tu nombre de usuario será visible para otros usuarios.",
  "username": "Nombre de Usuario",
  "username_placeholder": "Ingresa un nombre de usuario",
  "username_requirements": "El nombre de usuario solo puede contener letras, números y guiones bajos.",
  "save_username": "Guardar Nombre de Usuario",
  "username_taken": "Este nombre de usuario ya está en uso. Por favor, intenta con otro.",
  "username_set_success": "¡Nombre de usuario establecido con éxito!",
  "username_set_error": "Error al establecer el nombre de usuario. Por favor, inténtalo de nuevo.",
  "auth_error": "Error de autenticación. Por favor, intenta iniciar sesión nuevamente.",
  "sign_in_success": "¡Inicio de sesión exitoso!",
  "sign_in_failed": "Error al iniciar sesión",
  "completing_sign_in": "Completando inicio de sesión...",
  "please_wait": "Por favor espera mientras verificamos tus credenciales.",
  "or_continue_with": "O continuar con",
  "or_with_email": "O con correo electrónico",
  "continue_with_google": "Continuar con Google",
  "dont_have_account": "¿No tienes una cuenta?",
  "already_have_account": "¿Ya tienes una cuenta?",
  "magic_link_sent": "Enlace mágico enviado a tu correo",
  "magic_link_error": "Error al enviar el enlace mágico. Inténtalo de nuevo más tarde.",
  "send_magic_link": "Enviar Enlace Mágico"
};
